import React from "react";

const DashIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#3E4957"
      fillRule="evenodd"
      d="M2.5 10c0-.345.28-.625.625-.625h13.75a.625.625 0 1 1 0 1.25H3.125A.625.625 0 0 1 2.5 10Z"
      clipRule="evenodd"
    />
  </svg>
);
export default DashIcon;
